import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { Card } from "../components/ui/card";
import ReportForm from "../components/ReportForm";

export default function ReportIssue() {
  const [sites, setSites] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/sites").then((r) => setSites(r.data)).catch(() => {});
    api.get("/meta/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  const submit = async (payload) => {
    await api.post("/reports", payload);
    toast.success("Report submitted successfully");
  };

  return (
    <div>
      <PageHeader title="Report an Issue" subtitle="Fast reporting for hazards, near misses, positive spots and more." />
      <Card className="mx-auto max-w-2xl rounded-2xl border-border p-6 sm:p-8">
        {categories.length > 0 && <ReportForm categories={categories} sites={sites} requireName={false} onSubmit={submit} />}
      </Card>
    </div>
  );
}
